import React from "react"
import '../styles/styles.scss';
import MobileNav from './MobileNav'
import Footer from "./footer"
import * as layoutStyles from "./layout.module.scss"

import Header from "./header"

const Layout = props => {
  return (
    <div className={layoutStyles.container}>
      <a href="#main-content" className="skip-link">Skip to content</a>
      <Header homeNav={props.homeNav} />
      <MobileNav />
      <main className={layoutStyles.content} id="main-content">
        {props.children}
      </main>
      <Footer />
    </div>
  )
}

export default Layout
